/**
 * menus/type_1.js
 * theme_type = 'type_1' (PRIONE 기본) 전용 GNB 구성.
 * SITEMAPS: 햄버거 전체메뉴, MENUS: 상단 헤더메뉴.
 *
 * 수정 시 이 파일만 편집 — base.js의 원본 데이터는 건드리지 않아도 됩니다.
 */

import { SECTIONS, GROUPS, TABS } from './base.js';

// ---------------------------------------------------------------------------
// SITEMAPS — 햄버거 전체메뉴 구성
// ---------------------------------------------------------------------------

export const SITEMAPS = [
    {
        SECTION: SECTIONS.DIGITALS,
        GROUPS: [
            {
                GROUP: GROUPS.DIGITAL_BOOKLETS,
                TABS: [TABS.MAKE_A_BOOK, TABS.WITH_SPRINGS, TABS.WITH_MAGAZINES],
            },
            {
                GROUP: GROUPS.DIGITAL_POSTERS,
                TABS: [TABS.DIGITAL_POSTERS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_CATALOGS,
                TABS: [TABS.DIGITAL_CATALOGS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_LEAFLETS,
                TABS: [TABS.DIGITAL_LEAFLETS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_FLYERS,
                TABS: [TABS.DIGITAL_FLYERS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_INVITATIONS,
                TABS: [TABS.DIGITAL_INVITATIONS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_POSTCARDS,
                TABS: [TABS.DIGITAL_POSTCARDS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_BUSINESSCARDS,
                TABS: [TABS.DIGITAL_BUSINESSCARDS_STANDALONE],
            },
            {
                GROUP: GROUPS.DIGITAL_CALENDARS,
                TABS: [TABS.DIGITAL_CALENDARS_DESKTOPTYPES, TABS.DIGITAL_CALENDARS_WALLTYPE],
            },
            {
                GROUP: GROUPS.DIGITAL_SHEETS,
                TABS: [TABS.DIGITAL_SHEETS_STANDALONE],
            },
        ],
    },
    {
        SECTION: SECTIONS.OFFSETS,
        GROUPS: [
            {
                GROUP: GROUPS.OFFSET_BOOKLETS,
                TABS: [TABS.OFFSET_BOOKLETS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_POSTERS,
                TABS: [TABS.OFFSET_POSTERS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_CATALOGS,
                TABS: [TABS.OFFSET_CATALOGS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_LEAFLETS,
                TABS: [TABS.OFFSET_LEAFLETS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_FLYERS,
                TABS: [TABS.OFFSET_FLYERS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_INVITATIONS,
                TABS: [TABS.OFFSET_INVITATIONS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_POSTCARDS,
                TABS: [TABS.OFFSET_POSTCARDS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_BUSINESSCARDS,
                TABS: [TABS.OFFSET_BUSINESSCARDS_STANDALONE],
            },
            {
                GROUP: GROUPS.OFFSET_SHEETS,
                TABS: [TABS.OFFSET_SHEETS_STANDALONE],
            },
        ],
    },
    {
        SECTION: SECTIONS.LARGEFORMATS,
        GROUPS: [
            {
                GROUP: GROUPS.LARGEFORMAT_BANNERS,
                TABS: [TABS.LARGEFORMAT_BANNERS_STANDALONE],
            },
            {
                GROUP: GROUPS.LARGEFORMAT_HANGINGS,
                TABS: [TABS.LARGEFORMAT_HANGINGS_STANDALONE],
            },
            {
                GROUP: GROUPS.LARGEFORMAT_PRINTINGS,
                TABS: [TABS.LARGEFORMAT_PRINTINGS_STANDALONE],
            },
        ],
    },
];

// ---------------------------------------------------------------------------
// MENUS — 상단 헤더메뉴 구성
//
// 헤더에선 GROUP 단위로 탭을 묶어 노출
// 각 GROUP 아래에 SECTION별 탭 묶음을 배열로 나열
// ---------------------------------------------------------------------------

export const MENUS = [
    {
        GROUP: GROUPS.DIGITAL_BOOKLETS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.MAKE_A_BOOK, TABS.WITH_SPRINGS, TABS.WITH_MAGAZINES],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_BOOKLETS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_POSTERS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_POSTERS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_POSTERS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_CATALOGS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_CATALOGS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_CATALOGS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_LEAFLETS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_LEAFLETS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_LEAFLETS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_FLYERS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_FLYERS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_FLYERS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_INVITATIONS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_INVITATIONS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_INVITATIONS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_POSTCARDS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_POSTCARDS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_POSTCARDS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_BUSINESSCARDS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_BUSINESSCARDS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_BUSINESSCARDS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_CALENDARS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_CALENDARS_DESKTOPTYPES, TABS.DIGITAL_CALENDARS_WALLTYPE],
            },
        ],
    },
    {
        GROUP: GROUPS.DIGITAL_SHEETS,
        SECTIONS: [
            {
                SECTION: SECTIONS.DIGITALS,
                TABS: [TABS.DIGITAL_SHEETS_STANDALONE],
            },
            {
                SECTION: SECTIONS.OFFSETS,
                TABS: [TABS.OFFSET_SHEETS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.LARGEFORMAT_BANNERS,
        SECTIONS: [
            {
                SECTION: SECTIONS.LARGEFORMATS,
                TABS: [TABS.LARGEFORMAT_BANNERS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.LARGEFORMAT_HANGINGS,
        SECTIONS: [
            {
                SECTION: SECTIONS.LARGEFORMATS,
                TABS: [TABS.LARGEFORMAT_HANGINGS_STANDALONE],
            },
        ],
    },
    {
        GROUP: GROUPS.LARGEFORMAT_PRINTINGS,
        SECTIONS: [
            {
                SECTION: SECTIONS.LARGEFORMATS,
                TABS: [TABS.LARGEFORMAT_PRINTINGS_STANDALONE],
            },
        ],
    },
];
